import React from "react";
import { Link } from "react-router-dom";
import { RoomContext } from "../context";
import StyledHero from "../components/StyledHero";

import defaultImg from "../img/IMG_0638.JPG";

import NavbarClear from "../components/NavbarClear";
import Footer from "../components/Footer";
import Cta from "../components/Cta";

export default class SingleProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slug: this.props.match.params.slug,
      defaultImg,
    };
  }

  static contextType = RoomContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { getProject } = this.context;
    const project = getProject(this.state.slug);
    if (!project) {
      return (
        <div className="error">
          <h3>no such room could be found...</h3>
          <Link to="/projekty" className="btn-primary">
            back to rooms
          </Link>
        </div>
      );
    }

    const { name, description, images, extras } = project;
    const [mainImg] = images;

    return (
      <div>
        <div className="ofvajd">
          <NavbarClear logo="https://www.nabytekbatka.cz/BatkaSmall.svg" />
          <StyledHero
            className="project-main-img-div"
            img={mainImg || this.state.defaultBcg}
          />
          <h1 className="projects-title">{name}</h1>
          <hr className="project-hr"></hr>
          <div className="project-description-div">
            <ul className="quick-desc">
              <hr className="bighr"></hr>
              <li className="quick-desc-item">{extras[0]}</li>
              <li className="quick-desc-item">{extras[1]}</li>
              <li className="quick-desc-item">{extras[2]}</li>
            </ul>
            <p className="project-description">{description}</p>
          </div>
          <div className="project-img-div">
            <img alt="" src={images[0]} className="project-img"></img>
          </div>
          <div className="project-img-div">
            <img alt="" src={images[1]} className="project-img"></img>
          </div>

          <Link to="/projekty">
            <button className="project-btn">více projektů</button>
          </Link>
          <Cta />
          <Footer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SingleProject.js